'use client'

import { usePathname } from 'next/navigation'
import { Navbar } from './index'
import type { FeaturedResource } from './types'
import { getNavRouteConfig } from '@/lib/nav-route-config'

interface NavbarClientProps {
  featuredResource: FeaturedResource | null
}

export function NavbarClient({ featuredResource }: NavbarClientProps) {
  const pathname = usePathname()
  const navConfig = getNavRouteConfig(pathname)

  return (
    <Navbar
      variant={navConfig.variant}
      transparent={navConfig.transparent}
      featuredResource={featuredResource}
    />
  )
}
